import { render, staticRenderFns } from "./ClassForm.vue?vue&type=template&id=3baa911e&scoped=true"
import script from "./ClassForm.vue?vue&type=script&lang=js"
export * from "./ClassForm.vue?vue&type=script&lang=js"
import style0 from "./ClassForm.vue?vue&type=style&index=0&id=3baa911e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baa911e",
  null
  
)

export default component.exports